import type { ManagedInfo } from '../../api/types'
import { Icon } from '../../components/Icon'

/** "Managed": an integration controls who is in this channel or group chat. Only the tooltip names it. */
export function ManagedBadge({ managed }: { managed: ManagedInfo }) {
  return (
    <span className="managed-badge" title={`Membership is managed by ${managed.integrationName}`}>
      <Icon name="idCard" />
      <span className="managed-badge-text">Managed</span>
    </span>
  )
}
